import {Path} from 'react-hook-form'
import {IApplicationFormData, IWizardIncome} from '../../../models/application-form'

export const incomePath = (field: keyof IWizardIncome): Path<IApplicationFormData> => {
  return `income.${field}` as Path<IApplicationFormData>
}
